import { render, staticRenderFns } from "./Kam.vue?vue&type=template&id=65ef6b55&"
import script from "./Kam.vue?vue&type=script&lang=ts&"
export * from "./Kam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports